define('companiesListDeleteView',[
  'module',
  'tableFieldView',
  'template!companiesListDeleteView'
], function (
  Module,
  FieldView,
  Tpl
) {
  'use strict';

  // Per-row delete button for the companies list. Triggers 'company:delete' on
  // the parent table view (the controller handles confirmation + the request).
  Module.exports = FieldView.extend({
    template: Tpl,
    className: 'companies-list-delete-view ' + FieldView.prototype.className,

    ui: {
      deleteBtn: '.js-delete'
    },

    events: {
      'click @ui.deleteBtn': 'onDeleteClick'
    },

    // Override the base text rendering: the template already holds the icon.
    onRender: function () {},

    onDeleteClick: function (e) {
      e.preventDefault();
      e.stopPropagation();
      this.tableView.trigger('company:delete', this.model);
    }
  });
});

